import { z } from "zod";
import { AddressDeliveryFormSchema, AddressResponseSchema } from "./address";

export const PersonResponseSchema = z.object({
  first_name: z.string(),
  last_name: z.string(),
  email: z.string().email(),
  phone_number: z.string(),
  address: AddressResponseSchema,
});

export const PersonDeliveryFormSchema = z.object({
  first_name: z.string().min(1),
  last_name: z.string().min(1),
  email: z.string().email({ message: "validation.field.invalidEmail" }),
  phone_number: z
    .string()
    .regex(/^\+\d{2,4}/, { message: "validation.order.phone_prefix" })
    .regex(/^\+[0-9]+$/, { message: "validation.order.phone_digits_only" })
    .min(12, { message: "validation.order.phone_too_short" })
    .max(12, { message: "validation.order.phone_too_long" }),
  address: AddressDeliveryFormSchema,
});

export const PersonPickupFormSchema = z.object({
  first_name: z.string().min(1),
  last_name: z.string().min(1),
  email: z.string().email({ message: "validation.field.invalidEmail" }),
  phone_number: z
    .string()
    .regex(/^\+\d{2,4}/, { message: "validation.order.phone_prefix" })
    .regex(/^\+[0-9]+$/, { message: "validation.order.phone_digits_only" })
    .min(12, { message: "validation.order.phone_too_short" })
    .max(12, { message: "validation.order.phone_too_long" }),
});
